import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { generateAddedValueFormName } from '../../../helpers/form-added-value-name-generator';

@Injectable()
export class ResetCatalogsCommand implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value: any, form: UntypedFormGroup): void {
    if (!value) {
      // Reset contract if unselect
      const contractControl = form.get(SpecFieldNames.CONTRACT_SELECT);
      contractControl.setValue(undefined);
    }
    // Reset catalogs when change
    const unloadTypeControl = form.get(SpecFieldNames.UNLOAD_TYPE);
    if (unloadTypeControl.value) {
      unloadTypeControl.setValue(undefined);
    }

    const firstAddedValueControl = form.get(generateAddedValueFormName(0));
    const userTouched =
      form.get(SpecFieldNames.PRODUCT_SELECTION).dirty || form.get(SpecFieldNames.PRODUCT_SELECTION).touched;
    if (firstAddedValueControl.value && userTouched) {
      firstAddedValueControl.setValue(undefined);
    }
  }
}
